import AdsAudienceMembershipActionDetail from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionDetail';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { jsx as _jsx } from "react/jsx-runtime";
const AdsAudienceMembershipActionHistoryCard = ({
  actionLabel,
  actionMetadata
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(AdsAudienceMembershipActionDetail, {
      actionMetadata: actionMetadata
    })
  });
};
export default AdsAudienceMembershipActionHistoryCard;